// vim: ft=javascript:
export const backUrl = `${window.location.origin}/`
export const graphqlUrl = backUrl + 'graphql/'
export const fakeUser = false
